/*
 * GENERATED — DO NOT EDIT.
 * Source: @WorkerKmpWorkers annotation sites in the consumer's commonMain.
 */
@file:OptIn(
    io.github.mobilebytelabs.worker.ExperimentalWorkerApi::class,
    io.github.mobilebytelabs.worker.koin.WorkerKmpInternalApi::class,
)
package cmp.shared.generated

import io.github.mobilebytelabs.worker.config.WorkerConfig
import io.github.mobilebytelabs.worker.web.webWorkManagerFactory
import io.github.mobilebytelabs.worker.koin.WorkerKmpHost
import io.github.mobilebytelabs.worker.koin.WorkerKmpHostConfig
import io.github.mobilebytelabs.worker.koin.workKoinModulePrivateApi
import io.github.mobilebytelabs.worker.registry.workerRegistry
import org.koin.core.context.loadKoinModules
import org.koin.mp.KoinPlatform.getKoin
import org.koin.mp.KoinPlatformTools
import kpt.sync.infra.DataSyncWorker
import kpt.sync.infra.NotificationWorker

internal fun installWorkerKmpWeb() {
    val factory = webWorkManagerFactory()
    val registry = workerRegistry {
        register<kpt.sync.infra.DataSyncWorker> { ctx ->
            kpt.sync.infra.DataSyncWorker(
                context = ctx,
                currencyRepository = getKoin().get(),
                macroIndicatorsRepository = getKoin().get(),
                persister = getKoin().get(),
            )
        }
        register<kpt.sync.infra.NotificationWorker> { ctx ->
            kpt.sync.infra.NotificationWorker(
                context = ctx,
            )
        }
    }
    loadKoinModules(workKoinModulePrivateApi(WorkerConfig(), registry, factory))
    val koin = KoinPlatformTools.defaultContext().getOrNull()
    WorkerKmpHost.initialize(
        koin?.getOrNull(WorkerKmpHostConfig::class) ?: WorkerKmpHostConfig(),
    )
}
